import { render } from "./ProduOverv.vue?vue&type=template&id=44d5bedc&scoped=true"
import script from "./ProduOverv.vue?vue&type=script&lang=js"
export * from "./ProduOverv.vue?vue&type=script&lang=js"

import "./ProduOverv.vue?vue&type=style&index=0&id=44d5bedc&lang=stylus&scoped=true"
script.render = render
script.__scopeId = "data-v-44d5bedc"

export default script